// src/pages/CustomerList.jsx

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import { 
  Container, Paper, Typography, Button, Table, TableHead, TableRow, 
  TableCell, TableBody, IconButton, Box, CircularProgress 
} from "@mui/material";
import { 
  Delete as DeleteIcon, Edit as EditIcon, PersonAdd as PersonAddIcon, 
  Groups as GroupsIcon, FileDownload as DownloadIcon 
} from "@mui/icons-material";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function CustomerList() {
  const navigate = useNavigate();
  const companyId = localStorage.getItem('companyId');
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    axios.get(`/Customer/by-company/${companyId}`)
      .then(res => setCustomers(res.data))
      .catch(err => console.error('❌ خطأ في تحميل العملاء:', err))
      .finally(() => setLoading(false));
  }, [companyId]);

  const deleteCustomer = id => {
    if (!window.confirm('❗ هل أنت متأكد من حذف هذا العميل؟')) return;
    axios.delete(`/Customer/${id}`)
      .then(() => {
        setCustomers(cs => cs.filter(c => c.id !== id));
        alert('🗑️ تم حذف العميل');
      })
      .catch(() => alert('❌ حدث خطأ أثناء الحذف'));
  };

  const exportToExcel = () => {
    const data = customers.map((c, idx) => ({
      'رقم': idx + 1, 'الاسم': c.name, 'الرقم الضريبي': c.taxNumber || '-', 'الجوال': c.mobile || '-'
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'العملاء');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), "customers.xlsx");
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }} dir="rtl">
      {/* هيدر الصفحة العصري */}
      <Paper elevation={0} sx={{ p: 4, mb: 4, borderRadius: '24px', background: 'linear-gradient(135deg, #0f172a 0%, #334155 100%)', color: 'white' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <GroupsIcon sx={{ fontSize: 40 }} />
            <Typography variant="h4" fontWeight="800">📋 إدارة العملاء</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="outlined" onClick={exportToExcel} sx={{ color: 'white', borderColor: 'white', borderRadius: '12px' }} startIcon={<DownloadIcon />}>تصدير</Button>
            <Button variant="contained" onClick={() => navigate('/customers/new')} sx={{ bgcolor: 'white', color: '#1e293b', borderRadius: '12px', '&:hover': { bgcolor: '#e2e8f0' } }} startIcon={<PersonAddIcon />}>إضافة عميل</Button>
          </Box>
        </Box>
      </Paper>

      {/* جدول البيانات */}
      <Paper elevation={0} sx={{ p: 4, borderRadius: '24px', border: '1px solid #e2e8f0', overflowX: 'auto' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={5}><CircularProgress /></Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                {['#', 'الاسم', 'الرقم الضريبي', 'الجوال', 'إجراءات'].map(h => <TableCell key={h} align="center" sx={{ fontWeight: 'bold' }}>{h}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((c, idx) => (
                <TableRow key={c.id}>
                  <TableCell align="center">{idx + 1}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>{c.name}</TableCell>
                  <TableCell align="center">{c.taxNumber || '-'}</TableCell>
                  <TableCell align="center">{c.mobile || '-'}</TableCell>
                  <TableCell align="center">
                    <IconButton color="warning" onClick={() => navigate(`/customers/${c.id}/edit`)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => deleteCustomer(c.id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {customers.length === 0 && (
                <TableRow><TableCell colSpan={5} align="center" sx={{ py: 4 }}>لا يوجد بيانات لعرضها</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Container>
  );
}